/* eslint-disable no-unused-vars */

// @material-ui/icons
import React from 'react';
import {
  Notifications,Person
} from "@material-ui/icons";

import Chip from '@material-ui/core/Chip';
import SVGIcon from '@components/SvgIcon';

import NotificationsPage from "./Notifications/Notifications";

import {useFormatMessage as t} from '~/i18n/translate';

// error boundary
import ErrorBoundary from '@components/ErrorBoundary';
import Button from '@components/CustomButtons/Button'
import { mainColor } from '~/assets/jss/material-dashboard-react/components/sidebarStyle';

function Hello (){
  return (<div style={{color:'red'}}>
    Hello world !!
    <Button color="primary" >local </Button>
  </div>)
}

const rootRoutes = [
  // {
  //   path: "/hello",
  //   name: "hello world",
  //   rtlName: "إخطارات",
  //   icon: Notifications,
  //   component: Hello,
  //   layout: "/admin",
  //   navBarName:'hello'
  // },
  {
    path: "/notifications",
    name: "Notifications",
    rtlName: "إخطارات",
    icon: ()=> <Notifications style={{color:mainColor}} />,
    component: <NotificationsPage />,
    layout: "/admin",
    navBarName:'Notifications'
  }

];

export default rootRoutes;
